<template>
  <div class="price-detail">
    <div class="breadcrumb" style="background: #fff">查看特殊价格</div>
    <div class="third-title"><span> SKU组价格信息</span></div>
    <div class="order-detail-basic">
      <el-form :model="basicInfo" label-width="80px">
        <el-form-item label="平台号:">
          <span>{{ specialPriceVo.storeCode }}</span>
        </el-form-item>
        <el-form-item label="平台名称:">
          <span>{{ specialPriceVo.storeName }}</span>
        </el-form-item>
        <el-form-item v-if="specialPriceVo.applyType === 'APPLY_BASE' && $route.query.spuProperty !== 'NORMAL'" label="申请价格:">
          <el-table :data="specialPriceVo.specialPriceItemList" border width="100%">
            <el-table-column min-width="100px" prop="skuName" label="SKU名称"></el-table-column>
            <el-table-column prop="basePage" min-width="100px" label="基础P数"></el-table-column>
            <el-table-column prop="maxPage" min-width="100px" label="最大P数"></el-table-column>
            <el-table-column prop="baseStep" min-width="150px" label="一次增加P数"></el-table-column>
            <el-table-column prop="basePagePrice" min-width="150px" label="基础P平台价格"></el-table-column>
            <el-table-column prop="baseStepPrice" min-width="150px" label="增加一次平台价格"> </el-table-column>
            <el-table-column min-width="200px" label="申请基础P数价格" prop="price">
              <template slot-scope="scope"><span style="color:red">{{ scope.row.price }}</span></template>
            </el-table-column>
          </el-table>
        </el-form-item>
        <el-form-item v-if="specialPriceVo.applyType === 'APPLY_DISCOUNT' && $route.query.spuProperty !== 'NORMAL'" label="申请折扣:">
          <el-table :data="specialPriceVo.specialPriceItemList" border width="100%">
            <el-table-column prop="skuName" label="SKU名称"></el-table-column>
            <el-table-column prop="basePage" label="基础P数"></el-table-column>
            <el-table-column prop="maxPage" label="最大P数"></el-table-column>
            <el-table-column prop="baseStep" label="一次增加P数"></el-table-column>
            <el-table-column prop="basePagePrice" label="基础P平台价格"></el-table-column>
            <el-table-column prop="basePagePrice" label="申请基础P平台价格">
              <template slot-scope="scope"> {{ scope.row.basePagePrice * scope.row.price }} </template>
            </el-table-column>
            <el-table-column prop="baseStepPrice" label="增加一次平台价格"> </el-table-column>
            <el-table-column prop="baseStepPrice" label="申请增加一次平台价格">
              <template slot-scope="scope"> {{ scope.row.baseStepPrice * scope.row.price }} </template>
            </el-table-column>
            <el-table-column label="申请折扣" prop="price">
              <template slot-scope="scope"><span style="color:red">{{ scope.row.price }}</span></template>
            </el-table-column>
          </el-table>
        </el-form-item>
        <el-form-item v-if="specialPriceVo.applyType === 'APPLY_BASE' && $route.query.spuProperty === 'NORMAL'" label="申请价格:">
          <el-table :data="specialPriceVo.specialPriceItemList" border width="100%">
            <el-table-column min-width="100px" prop="skuName" label="SKU名称"></el-table-column>
            <el-table-column prop="basePagePrice" min-width="150px" label="基础价格"></el-table-column>
            <el-table-column min-width="200px" label="申请价格" prop="price">
              <template slot-scope="scope"><span style="color:red">{{ scope.row.price }}</span></template>
            </el-table-column>
          </el-table>
        </el-form-item>
        <el-form-item v-if="specialPriceVo.applyType === 'APPLY_DISCOUNT' && $route.query.spuProperty === 'NORMAL'" label="申请折扣:">
          <el-table :data="specialPriceVo.specialPriceItemList" border width="100%">
            <el-table-column prop="skuName" label="SKU名称"></el-table-column>
            <el-table-column prop="basePagePrice" label="基础价格"></el-table-column>
            <el-table-column prop="basePagePrice" label="申请价格">
              <template slot-scope="scope"> {{ scope.row.basePagePrice * scope.row.price }} </template>
            </el-table-column>
            <el-table-column label="申请折扣" prop="price">
              <template slot-scope="scope"><span style="color:red">{{ scope.row.price }}</span></template>
            </el-table-column>
          </el-table>
        </el-form-item>
      </el-form>
    </div>
    <div class="edit-button">
      <el-button @click="check('AUDIT_FAIL')" v-if="$route.query.auditStatus === 'WAIT_AUDIT'" round type="primary">审核拒绝</el-button>
      <el-button @click="check('AUDIT_SUCCESS')" v-if="$route.query.auditStatus === 'WAIT_AUDIT'" round type="primary">审核通过</el-button>
      <el-button @click="$router.go(-1)" v-if="$route.query.auditStatus !== 'WAIT_AUDIT'" round type="primary">确定</el-button>
    </div>
    <CombinedDialog ref="dialogRef"></CombinedDialog>
  </div>
</template>
<script>
import CombinedDialog from '@/components/Dialog/CombinedDialog/index'
import { skuSpecialGet, skuSpecialAudit } from '@/api/pms'
export default {
  name: 'price-detail',
  components: {
    CombinedDialog
  },
  data () {
    return {
      isShow: false,
      basicInfo: {},
      isEdit: false,
      specialPriceVo: {
        applyType: '0',
        specialPriceItemList: [
          {
            id: 90001,
            price: 10,
            basePage: 0,
            basePagePrice: 1,
            baseStep: '0',
            baseStepPrice: 1,
            maxPage: '1',
            skuName: 'c0/1'
          }
        ]
      }
    }
  },
  mounted () {
    sessionStorage.setItem('searchFlag', true)
  },
  created () {
    this.getSpecialMsg()
  },
  methods: {
    // 审核
    check (status) {
      skuSpecialAudit({ specialId: this.$route.query.id, status }).then(res => {
        ;
        if (res.data.success) {
          if (status === 'AUDIT_FAIL') {
            this.$message.success('已拒绝')
          } else if (status === 'AUDIT_SUCCESS') {
            this.$message.success('已通过')
          }
          this.$router.go(-1)
        }
      })
    },
    // 获取特殊价格详情
    getSpecialMsg () {
      skuSpecialGet(this.$route.query.id).then(res => {
        ;
        if (res.data.success) {
          this.specialPriceVo = res.data.data
        }
      })
    }
  }
}
</script>
<style scoped lang="less">
@import "styles";
@deep: ~">>>";
</style>
